import { DateTime } from 'luxon';

export const SumDaysFromNow = (date: Date, days: number) =>
  DateTime.fromJSDate(date).plus({ days: days }).startOf('day').toJSDate();
